import {TranslateModule} from '@ngx-translate/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";
import {CommonDirectiveModule} from "../../directives/common.directive.module";
import {SharingModule} from "../../sharing/sharing.module";
import {TimeManagementRoutingModule} from "./time-management-routing.module";
import {NgbPaginationModule, NgbTimepickerModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {MatDialogModule} from "@angular/material/dialog";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatButtonModule} from "@angular/material/button";
import {BsModalService} from "ngx-bootstrap/modal";
import {FullCalendarModule} from "@fullcalendar/angular";
import {WorkingInformationComponent} from "./presence-management/working-information/working-information.component";
import {TooltipModule} from 'ng2-tooltip-directive';
import {CollapseModule} from "ngx-bootstrap/collapse";
import {MatTabsModule} from "@angular/material/tabs";
import {NgSelect2Module} from "ng-select2";
import {NgxFileDropModule} from 'ngx-file-drop';
import {BsDatepickerConfig, BsDatepickerModule } from 'src/libs/core/src/datepicker';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {TimemanagementComponent} from './timemanagement.component';

@NgModule({
    declarations: [
        TimemanagementComponent
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        CommonDirectiveModule,
        SharingModule,
        TimeManagementRoutingModule,
        BsDatepickerModule.forRoot(),
        NgbPaginationModule,
        MatDialogModule,
        MatInputModule,
        MatRadioModule,
        MatButtonModule,
        NgxDaterangepickerMd.forRoot(),
        TranslateModule,
        FullCalendarModule,
        TooltipModule,
        CollapseModule,
        MatTabsModule,
        NgSelect2Module,
        NgbTimepickerModule,
        NgxFileDropModule,
        NgbTooltipModule,
    ],
    providers: [BsDatepickerConfig, BsModalService, DatePipe]
})

export class TimeManagementModule {
}
